import { Component } from "@angular/core";
import { CurrentPhoneCallService } from "@modules/participant-shared/services/current-phone-call.service";
import { map, Observable } from "rxjs";

/**
 * Dialog component to show the user whether the current participant is verified during a phone call.
 */
@Component({
    selector: 'app-participant-phone-call-is-verified-dialog',
    templateUrl: './participant-phone-call-is-verified-dialog.component.html',
    styleUrls: ['./participant-phone-call-is-verified-dialog.component.scss'],
})
export class ParticipantPhoneCallIsVerifiedDialogComponent {
    public readonly isVerified: boolean;
    public readonly participantName: Observable<string | undefined>;
    public readonly dateOfBirth: Observable<Date | undefined>;
    public readonly ssnLastFour: Observable<string | undefined>;
    public readonly address: Observable<string | undefined>;

    constructor(
        currentPhoneCallService: CurrentPhoneCallService,
    ) {
        this.isVerified = currentPhoneCallService.isParticipantVerified();

        this.participantName = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.participantName));
        this.dateOfBirth = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.dateOfBirth));
        this.ssnLastFour = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.ssnLastFour));
        this.address = currentPhoneCallService.currentPhoneCallChanged()
            .pipe(map(phoneCall => phoneCall?.address));
    }
}